import { render, staticRenderFns } from "./customerWorkspace.vue?vue&type=template&id=5f734d30&"
import script from "./customerWorkspace.vue?vue&type=script&lang=js&"
export * from "./customerWorkspace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f734d30')) {
      api.createRecord('5f734d30', component.options)
    } else {
      api.reload('5f734d30', component.options)
    }
    module.hot.accept("./customerWorkspace.vue?vue&type=template&id=5f734d30&", function () {
      api.rerender('5f734d30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Sales/components/crm/customerWorkspace.vue"
export default component.exports